
  import config from "../../../config";
  import cspMixin from "../../../mixins/cspMixin";
  import CustomerSummary from "../../../models/csp/CustomerSummaryCSP";
  import utils from "../../../utils/utils";

  export default {
    name: "ProjectTypeCspKpi",
    mixins: [cspMixin],
    props: {
      clientId: Number,
      projectId: Number
    },
    data() {
      return {
        text: {
          subscriptions: this.$tc("typeSubscriptions", 1),
          licences: this.$t("licences"),
          azurePlans: this.$t("azurePlans"),
          currentCost: this.$t("currentCost")
        },
        customerId: null,
        summary: new CustomerSummary({
          licences: undefined,
          azurePlans: undefined,
          subscriptionTypes: undefined,
          currentCost: undefined
        })
      };
    },
    async mounted() {
      const tenant = localStorage.getItem(
        `lastVisitedTenantCSP_${this.projectId}`
      );
      if (tenant) {
        this.customerId = tenant;
      } else if (this.getClientById(this.clientId).tenant != null) {
        this.customerId = this.getClientById(this.clientId).tenant.split(
          ","
        )[0];
      }
      if (this.customerId) {
        await this.loadAllSubscriptionCSPIdsByCustomerId(this.customerId);
        await this.loadCustomerBillingSummaryCSP(this.customerId);
        if (this.getNonAzurePlanSubscriptionsCSP(this.customerId).length != 0) {
          if (config.prodEnv) {
            await this.loadLicencesBillingsCSP(this.customerId);
          }
        }
        await this.setCustomerSummary();
      }
    },
    methods: {
      localeFormatNumber(value) {
        return utils.localeFormatNumber(
          value,
          utils.getLocaleByUserLanguage(this.getUser)
        );
      },
      async setCustomerSummary() {
        let licencesCount = 0;
        for (const sub of this.getNonAzurePlanSubscriptionsCSP(
          this.customerId
        )) {
          licencesCount += sub.quantity;
        }
        this.summary.setLicences = licencesCount;
        this.summary.setAzurePlans = this.getAzurePlanSubscriptionsCSP(
          this.customerId
        ).length;
        this.summary.setSubscriptionTypes = this.getSubscriptionsCSP(
          this.customerId
        ).length;
        this.summary.setCurrentCost = await this.getEstimatedCost(
          this.customerId
        );
      }
    }
  };
